import React, { useContext } from "react";
import { FileCheck } from "lucide-react";
import { ReadOnlyContext } from "../ReadOnlyContext";

const Button = ({ btnLoading, onClick, title = "Submit CAM", showInReadOnly = false }) => {
  const isReadOnly = useContext(ReadOnlyContext);

  if (isReadOnly && !showInReadOnly) {
    return null;
  }

  return (
    <button
      onClick={onClick}
      disabled={btnLoading}
      style={{
        opacity: btnLoading ? 0.6 : 1,
        cursor: btnLoading ? "not-allowed" : "pointer",
        height: "fit-content",
        marginTop: "10px",
        backgroundColor: "#024e5a",
        color: "#fff",
        border: "none",
        padding: "8px 16px",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "12px",
        fontWeight: 600,
        transition: "opacity 0.15s ease",
      }}
    >
      {btnLoading ? (
        <>
          <span style={{ display: "inline-block", marginRight: "8px" }}>
            <i className="fa fa-spinner fa-spin"></i>
          </span>
          Loading...
        </>
      ) : (
        <>
          <FileCheck
            style={{
              strokeWidth: "1.2px",
              color: "#fff",
              height: "16px",
              width: "16px",
            }}
          />{" "}
          {title}
        </>
      )}
    </button>
  );
};

export default Button;
